<div class="search">
    <mat-icon class="visible-small-only"
             (click)="isShowSearchOverlay = true">search
    </mat-icon>
    <div class="search-overlay overlay"
         tabindex="1"
         *ngIf="isShowSearchOverlay"
         (keydown)="overlayKeyDown($event)">
        <mat-icon class="close-overlay" (click)="isShowSearchOverlay = false">close</mat-icon>
        <ng-container [ngTemplateOutlet]="search"></ng-container>
        <upsc-element-blocker *ngIf="isSearching"></upsc-element-blocker>
    </div>
    <div class="visible-medium-up">
        <ng-container [ngTemplateOutlet]="search"></ng-container>
        <upsc-element-blocker *ngIf="isSearching"></upsc-element-blocker>
    </div>
</div>

<ng-template #search>
    <form #searchForm="ngForm"
          class="search-form"
          [formGroup]="formGroup"
          (ngSubmit)="onFormSubmitted($event, formGroup.value)">
        <mat-form-field floatLabel="auto">
            <input matInput
                   type="search"
                   placeholder="Site search"
                   tabindex="0"
                   formControlName="keyword">
            <mat-icon matSuffix
                     class="search-icon"
                     (click)="searchForm.ngSubmit.emit($event)">search</mat-icon>
        </mat-form-field>
    </form>
</ng-template>